// import React, { useEffect } from "react";
// import { getSEOData } from "../../../global/utils/constants/seoConfig";
// import SEO from "../../../global/components/SEO/SEO";
// import "../Style/productDetails.css";
// import ProductTopWrapper from "../Components/ProductTopWrapper";
// import ProductTab from "../Components/ProductTab";
// import { useParams } from "react-router-dom";
// import { fetcher } from "../../../lib/api";
// import useSWR from "swr";

// const ProductDetails = () => {
//   const { id } = useParams();

//   const {
//     data: product,
//     isLoading: productLoading,
//     error: productError,
//     mutate: mutateProducts,
//   } = useSWR(`/product/${id}`, fetcher);

//   // Get SEO data for product details
//   const seoData = getSEOData(`/product/${id}`);

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [id]);

//   if (productLoading)
//     return (
//       <div className="h-screen flex items-center justify-center">
//         Loading...
//       </div>
//     );
//   if (productError) return <div>Error: {productError.message}</div>;

//   // Dynamic SEO title and description based on product data
//   const productTitle = product?.name
//     ? `${product.name} - Access Control Product | Sicunet`
//     : seoData.title;

//   const productDescription = product?.description
//     ? `${product.description.substring(0, 150)}...`
//     : seoData.description;

//   return (
//     <>
//       <SEO
//         title={productTitle}
//         description={productDescription}
//         keywords={seoData.keywords}
//         type="website"
//       />
//       <div className="max-w-[1200px] max-xl:max-w-full mx-auto py-10 max-xl:px-6">
//         <ProductTopWrapper product={product} />
//         <ProductTab product={product} />
//       </div>
//     </>
//   );
// };

// export default ProductDetails;
import React, { useEffect } from "react";
import { getSEOData } from "../../../global/utils/constants/seoConfig";
import SEO from "../../../global/components/SEO/SEO";
import "../Style/productDetails.css";
import ProductTopWrapper from "../Components/ProductTopWrapper";
import ProductTab from "../Components/ProductTab";
import { useParams } from "react-router-dom";
import { fetcher } from "../../../lib/api";
import useSWR from "swr";
import { Spin } from "antd";

const ProductDetails = () => {
  const { id } = useParams();

  const {
    data: product,
    isLoading: productLoading,
    error: productError,
    mutate: mutateProducts,
  } = useSWR(`/product/${id}`, fetcher);

  // Get SEO data for product details
  const seoData = getSEOData(`/product/${id}`);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  if (productLoading)
    return (
      <div className="h-screen flex items-center justify-center">
        <Spin size="large" />
      </div>
    );
  if (productError) return <div>Error: {productError.message}</div>;

  // Dynamic SEO title and description based on product data
  const productTitle = product?.name
    ? `${product.name} - Access Control Product | Sicunet`
    : seoData.title;

  const productDescription = product?.description
    ? `${product.description.substring(0, 150)}...`
    : seoData.description;

  return (
    <>
      <SEO
        title={productTitle}
        description={productDescription}
        keywords={seoData.keywords}
        type="website"
      />
      <div className="max-w-[1200px] max-xl:max-w-full mx-auto py-10 max-xl:px-6">
        <ProductTopWrapper product={product} />
        <ProductTab product={product} />
      </div>
    </>
  );
};

export default ProductDetails;
